module.exports = __webpack_public_path__ + "static/assets/020712374240c3cc5a731984a6beb7bd.png";